import axiosInstance from "@/plugins/axios";

export const EvaluationPJPService = {
  findAll: async ({
    page,
    size,
    search,
    status_id,
    contractor_id,
    isafeno,
    year_period,
    period,
  }) => {
    const response = await axiosInstance.get(`cms/evaluation-pjp`, {
      params: {
        page,
        size,
        search,
        status_id,
        contractor_id,
        isafeno,
        year_period,
        period,
      },
    });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get(`cms/evaluation-pjp/${id}`);
    return response.data;
  },
  store: async ({
    contractor_id,
    pjo_name,
    periode,
    presentation_date,
    aspects,
  }) => {
    const response = await axiosInstance.post(`cms/evaluation-pjp`, {
      contractor_id,
      pjo_name,
      periode,
      presentation_date,
      aspects,
    });
    return response.data;
  },
  update: async ({
    id,
    contractor_id,
    pjo_name,
    periode,
    presentation_date,
    aspects,
  }) => {
    const response = await axiosInstance.put(`cms/evaluation-pjp/${id}`, {
      contractor_id,
      pjo_name,
      periode,
      presentation_date,
      aspects,
    });
    return response.data;
  },
  destroy: async (id) => {
    const response = await axiosInstance.delete(`cms/evaluation-pjp/${id}`);
    return response.data;
  },
  approvalNC: async ({ id, notes, action, is_mitra, category }) => {
    const response = await axiosInstance.put(
      `cms/api/evaluasi-pjp/nc/items/${id}/approval`,
      {
        notes,
        action,
        is_mitra,
        category,
      },
    );
    return response.data;
  },
  getContractor: async () => {
    const response = await axiosInstance.get("cms/evaluation-pjp/kontraktor");
    return response.data;
  },
  getStatusReport: async ({ evaluation_id, recap }) => {
    const response = await axiosInstance.get(
      "cms/evaluation-pjp/status-report",
      {
        params: { evaluation_id },
      },
    );

    recap.total = response.data.data[0].total_nc || 0;
    recap.type?.forEach((item) => {
      const data = response.data.data[0].statuses?.find(
        (st) => st.status_id === item.id,
      );
      if (data) {
        item.items = data.total;
        item.totalItems = response.data.data[0].total_nc || 0;
      }
    });

    return recap;
  },
  getEvaluationPjpByKontraktorPeriode: async ({ contractor_id, periode }) => {
    const response = await axiosInstance.get(
      `cms/evaluation-pjp/by-kontraktor-periode`,
      {
        params: { kontraktor_id: contractor_id, periode },
      },
    );
    return response.data;
  },
  submitAspectDetailSelfAssessment: async (payload) => {
    const response = await axiosInstance.patch(
      `/cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/self-assessments`,
      payload,
    );
    return response.data;
  },
  updateEvaluator: async (payload) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/evaluator`,
      payload,
    );
    return response.data;
  },
  submitAspectDetailEvaluatorAssessment: async ({
    aspect_evaluation_pjp_id,
    evaluator_id,
    evaluator_name,
    evaluator_isafe_no,
    detail_aspect,
  }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/self-assessments/evaluator`,
      {
        aspectEvaluationPjpId: aspect_evaluation_pjp_id,
        evaluatorId: evaluator_id,
        evaluatorName: evaluator_name,
        evaluatorIsafeNo: evaluator_isafe_no,
        detailAspect: detail_aspect,
      },
    );
    return response.data;
  },
  submitAspectDetailEvaluatorAssessmentSubmit: async ({
    evaluation_id,
    aspect_evaluation_ids,
    auditor_isafeno,
  }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/self-assessments/evaluator/submit`,
      {
        evaluationId: evaluation_id,
        aspectEvaluationIds: aspect_evaluation_ids,
        auditorIsafeno: auditor_isafeno,
      },
    );
    return response.data;
  },
  getAspectEvaluationDetailPjpEvidencesById: async ({ id }) => {
    const response = await axiosInstance.get(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/${id}/evidences`,
    );
    return response.data;
  },
  uploadEvidencesAspectDetail: async ({ id, evidences }) => {
    const response = await axiosInstance.put(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/${id}/evidences`,
      evidences,
    );
    return response.data;
  },
  syncAspectEvaluationDetailPjp: async ({
    evaluation_id,
    created_by,
    created_by_user,
  }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/sync`,
      {
        evaluationId: evaluation_id,
        createdBy: created_by,
        createdByUser: created_by_user,
      },
    );
    return response.data;
  },
  getAspectEvaluationDetailPjp: async ({
    evaluation_id,
    aspect_evaluation_id,
  }) => {
    const response = await axiosInstance.get(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp`,
      {
        params: {
          evaluationId: evaluation_id,
          aspectEvaluationId: aspect_evaluation_id,
        },
      },
    );
    return response.data;
  },
  getAspectEvaluationDetailPjpById: async (id) => {
    const response = await axiosInstance.get(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/${id}`,
    );
    return response.data;
  },
  calculateAspectSelfAssessment: async ({ evaluation_id }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/calculate-aspect-self-assessment`,
      {
        evaluationId: evaluation_id,
      },
    );
    return response.data;
  },
  uploadDocPresentationPath: async ({ id, doc_url_presentation }) => {
    const response = await axiosInstance.put(
      `cms/api/evaluasi-pjp/${id}/doc-presentation-path`,
      { docUrlPresentation: doc_url_presentation },
    );
    return response.data;
  },
  getAspectEvaluationPinaltyPjp: async ({ evaluation_id, self_assesment }) => {
    const response = await axiosInstance.get(
      `cms/api/evaluasi-pjp/aspect-evaluation-pinalty-pjp`,
      {
        params: {
          evaluationId: evaluation_id,
          self_assesment: self_assesment,
        },
      },
    );
    return response.data;
  },
  syncAspectEvaluationPinaltyPjp: async ({ evaluation_id }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-pinalty-pjp/sync`,
      {
        evaluationPjp: evaluation_id,
      },
    );
    return response.data;
  },
  getSummarySelfAssessment: async ({ id, calculate = false }) => {
    const response = await axiosInstance.get(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/${id}/summary-self-assesment`,
      {
        params: { calculation: calculate },
      },
    );
    return response.data;
  },
  updateAspectEvaluationPinaltyPjpById: async ({
    id,
    is_checked,
    is_checked_self_assessment,
  }) => {
    const response = await axiosInstance.put(
      `cms/api/evaluasi-pjp/aspect-evaluation-pinalty-pjp/${id}`,
      { isCheck: is_checked, isCheckSelfAssesment: is_checked_self_assessment },
    );
    return response.data;
  },
  submitSelfAssessment: async ({ id }) => {
    const response = await axiosInstance.put(
      `cms/evaluation-pjp/${id}/submit-self-assessment`,
    );
    return response.data;
  },
  destroyAspectEvaluationDetailPjp: async ({ id, aspect_evaluation_ids }) => {
    const response = await axiosInstance.delete(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/${id}`,
      { data: aspect_evaluation_ids },
    );
    return response.data;
  },
  approveScoreEvaluator: async ({ evaluation_id, aspect }) => {
    const response = await axiosInstance.post(
      `cms/evaluation-pjp/approve-score-evaluator`,
      {
        evaluationId: evaluation_id,
        aspect,
      },
    );
    return response.data;
  },
  releaseScoreEvaluator: async (evaluation_id) => {
    const response = await axiosInstance.post(
      `cms/evaluation-pjp/release-score`,
      {
        evaluationId: evaluation_id,
      },
    );
    return response.data;
  },
  syncAspectEvaluationPinaltyPjpEvaluator: async ({ evaluation_id }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-pinalty-pjp/sync/evaluator`,
      {
        evaluationPjp: evaluation_id,
      },
    );
    return response.data;
  },
  getSummaryEvaluator: async ({ id, calculation = false }) => {
    const response = await axiosInstance.get(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/${id}/summary-evaluator`,
      {
        params: { calculation: calculation },
      },
    );
    return response.data;
  },
  setNotesEvaluator: async ({ payload }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/self-assessments/evaluator/notes`,
      payload,
    );
    return response.data;
  },
  approveNotesEvaluator: async ({ payload }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/self-assessments/evaluator/notes/approve`,
      payload,
    );
    return response.data;
  },
  releaseNcEvaluator: async ({ evaluation_id }) => {
    const response = await axiosInstance.post(
      `cms/api/evaluasi-pjp/aspect-evaluation-detail-pjp/release-nc`,
      {
        evaluationId: evaluation_id,
      },
    );
    return response.data;
  },
  getDashboard: async ({
    periode,
    contractor_id,
    aspect_id,
    area,
    exportParam,
    contractorPart,
    aspectPart,
    areaPart,
  }) => {
    const response = await axiosInstance.get(`cms/api/evaluasi-pjp/dashboard`, {
      params: {
        periode,
        kontraktor_id: contractor_id,
        aspect_id: aspect_id,
        area,
        export: exportParam,
      },
      ...(exportParam && {
        responseType: "blob",
      }),
    });
    if (exportParam) {
      const filename = `NC Evaluasi PJP Dashboard_${contractorPart}_${aspectPart}_${areaPart}_${periode}.xlsx`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      return response.data;
    }
  },
  getDashboardKepatuhan: async ({
    periode,
    contractor_id,
    aspect_id,
    area,
    exportParam,
    contractorPart,
    aspectPart,
    areaPart,
    is_mitra,
    level,
  }) => {
    const response = await axiosInstance.get(
      `cms/api/evaluasi-pjp/dashboard/kepatuhan`,
      {
        params: {
          periode,
          contractor_id,
          aspect_evaluation_id: aspect_id,
          area,
          export: exportParam,
          is_mitra,
          level,
        },
        ...(exportParam && {
          responseType: "blob",
        }),
      },
    );
    if (exportParam) {
      let filename;
      if (is_mitra) {
        filename = `NC Evaluasi PJP Dashboard Kepatuhan Mitra_${contractorPart}_${periode}.xlsx`;
      } else {
        filename = `NC Evaluasi PJP Dashboard Kepatuhan Evaluator_${contractorPart}_${aspectPart}_${areaPart}_${periode}.xlsx`;
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      return response.data;
    }
  },
  readNotifLog: async (id) => {
    const response = await axiosInstance.put(
      `cms/api/evaluasi-pjp/notif-log/${id}/read`,
    );
    return response.data;
  },
  draftEmailEvaluator: async ({ evaluation_id }) => {
    const response = await axiosInstance.post(
      `cms/evaluation-pjp/${evaluation_id}/draft-email-evaluator`,
    );
    return response.data;
  },
  getDraftEmailCount: async (evaluation_id) => {
    const response = await axiosInstance.get(
      `cms/evaluation-pjp/draft-email-count`,
      {
        params: {
          evaluation_pjp_id: evaluation_id,
        },
      },
    );
    return response.data;
  },
};
